module.exports = __webpack_public_path__ + "assets/img/title-a05286be.png";